import { getDateTimeRangePayload } from "@/helper/dateHelper";
import { isNotSet } from "@/tools/format.checker";
import { FileType, ReportType } from "@/types/static.types";
import moment from "moment";

import hungerApi from "../api/hunger.api";

export class GetReportHelper {
  private startAt: moment.Moment;
  private endAt: moment.Moment;
  private readonly storeId: number;
  private readonly reportType: ReportType;

  constructor(config: {
    startAt: moment.Moment;
    endAt: moment.Moment;
    storeId: number;
    reportType: ReportType;
  }) {
    this.startAt = config.startAt;
    this.endAt = config.endAt;
    this.storeId = config.storeId;
    this.reportType = config.reportType;
  }

  handleClick = async () => {
    const { url } = await this.postRequired();
    if (isNotSet(url)) {
      return;
    }
    this.handleDownload(url);
  };

  private postRequired = async () => {
    const { data } = await hungerApi.post<FileType>(
      `/api/v3/mgt/dashboard/storeSummary/${this.storeId}/peroid/report`,
      {
        reportType: this.reportType,
        time: getDateTimeRangePayload(this.startAt, this.endAt),
      }
    );

    return data;
  };

  private handleDownload = (href: string) => {
    const atag = document.createElement("a");
    atag.download = "true";
    atag.href = href;
    atag.click();
  };
}
